

import __layout_0 from '/rails/app/frontend/layouts/default.vue'
export const layouts = {
'blank': () => import('/rails/app/frontend/layouts/blank.vue'),
'client': () => import('/rails/app/frontend/layouts/client.vue'),
'default': __layout_0,
'components/ClientLayoutWithVerticalNav': () => import('/rails/app/frontend/layouts/components/ClientLayoutWithVerticalNav.vue'),
'components/ClientUserProfile': () => import('/rails/app/frontend/layouts/components/ClientUserProfile.vue'),
'components/DefaultLayoutWithHorizontalNav': () => import('/rails/app/frontend/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/rails/app/frontend/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/rails/app/frontend/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/rails/app/frontend/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/rails/app/frontend/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/rails/app/frontend/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/rails/app/frontend/layouts/components/NavbarThemeSwitcher.vue'),
'components/PlatformSubscriptionBanner': () => import('/rails/app/frontend/layouts/components/PlatformSubscriptionBanner.vue'),
'components/TrainerLifecycleBanner': () => import('/rails/app/frontend/layouts/components/TrainerLifecycleBanner.vue'),
'components/UserProfile': () => import('/rails/app/frontend/layouts/components/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
